module.exports = __webpack_public_path__ + "img/logo-Micro2.764537f0.png";